import { render, staticRenderFns } from "./ZhuYuanRiQingDan.vue?vue&type=template&id=994d1928&scoped=true"
import script from "./ZhuYuanRiQingDan.vue?vue&type=script&lang=js"
export * from "./ZhuYuanRiQingDan.vue?vue&type=script&lang=js"
import style0 from "./ZhuYuanRiQingDan.vue?vue&type=style&index=0&id=994d1928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d1928",
  null
  
)

export default component.exports